import styled from '@emotion/styled'
import { css } from '@emotion/react'

import media from '../../../styles/media'

const S = {}

S.LinkSection = styled.div`
  ${({ isMinimal }) =>
    !isMinimal &&
    css`
      display: flex;
      column-gap: 1.25rem;
      border-bottom: 0.125rem solid;
      padding-block: 1.25rem;

      &:first-of-type {
        padding-top: 0;
      }

      &:nth-last-of-type(2) {
        border-bottom: none;
        padding-bottom: 0;
      }

      &:last-of-type {
        display: none;

        ${media.md`
          display: flex;
        `};
      }

      ${media.sm`
        flex-direction: column;
        border-bottom: none;
        padding-block: 0;
        flex-basis: 33.33%;
      `};

      ${media.md`
        flex-basis: 25%;
      `};
    `};

  .link-section-title {
    margin: 0;
    width: 37.3135%;
    min-width: 7.8125rem;
    word-break: break-word;
    overflow-wrap: break-word;
    display: ${({ isMinimal }) => isMinimal && 'none'};

    ${media.sm`
      margin-bottom: 0.75rem;
      width: 100%;
    `};
  }
`

S.List = styled.ul`
  margin: ${({ isMinimal }) => (isMinimal ? '0' : '0.25rem 0 0')};
  padding: 0;
  list-style-type: none;

  ${media.sm`
    margin-top: 0;
  `};

  .loading {
    > *:not(:last-of-type) {
      margin-block-end: 0.75rem;
    }
  }

  ${({ isMinimal }) =>
    isMinimal &&
    css`
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      text-align: center;

      ${media.sm`
        max-width: 30rem;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: center;
        column-gap: 1.0625rem;
        row-gap: 0.625rem;
        margin-inline: auto;

        > li {
          margin-bottom: 0;

          &:not(:last-of-type)::after {
            content: '';
            margin-inline-start: 1.0625rem;
          }
        }
      `};

      ${media.md`
        max-width: 100%;
      `};
    `};
`

export default S
